export const API_ERROR = "api_failed";

export const SR_PURCHASE_ORDER_LIST = "SR_purchase_Ordert_List";
export const SR_PURCHASE_ORDER_LIST_SUCCESS =
  "SR_purchase_Ordert_List_Successful";

export const SR_SERVICE_INDENT_LIST = "SR_service_indentt_List";
export const SR_SERVICE_INDENT_LIST_SUCCESS =
  "SR_service_indentt_List_Successful";
export const SR_PURCHASE_ORDER_ROW_DATA = "SR_purchase_Ordert_row_data";
export const SR_PURCHASE_ORDER_ROW_DATA_SUCCESS =
  "SR_purchase_Ordert_row_data_Successful";
export const SERVICE_REQUEST_NO_SELECT_SR_CHANGEVALUE =
  "Q_service_request_Select_SR_ChangeValue";
export const SELECT_SERVICE_REQUEST_CHANGEVALUE =
  "Q_Select_Service_Request_ChangeValue";
export const SR_SERVICE_REQUEST_ROW_DATA = "Q_SR_service_request_row_data";
export const SR_SERVICE_REQUEST_ROW_DATA_SUCCESS =
  "Q_SR_service_request_row_data_success";
export const SR_SERVICE_REQUEST_Q_VENDORS_LIST =
  "SR_service_request_q_vendors_list";
export const SR_SERVICE_REQUEST_Q_VENDORS_LIST_SUCCESS =
  "sR_service_request_q_vendors_success";
export const SERVICE_REQUEST_Location_SELECT_SR_CHANGEVALUE =
  "Q_service_request_Select_Location_ChangeValue";

export const SR_SERVICE_REQUEST_ITEM_QTY_SR_CHANGEVALUE =
  "item_service_request_qty_SR_ChangeValue";
export const SR_SERVICE_REQUEST_ITEM_UNIT_SR_CHANGEVALUE =
  "item_service_request_unit_SR_ChangeValue";
export const SR_SERVICE_REQUEST_ITEM_PRICE_SR_CHANGEVALUE =
  "item_service_request_price_SR_ChangeValue";
export const SR_SERVICE_REQUEST_ITEM_BASEPRICE_SR_CHANGEVALUE =
  "item_service_request_baseprice_SR_ChangeValue";
export const SR_SERVICE_REQUEST_ITEM_DISC_PERCENT_SR_CHANGEVALUE =
  "item_service_request_desc_percent_SR_ChangeValue";
export const SR_SERVICE_REQUEST_ITEM_TAX_SR_CHANGEVALUE =
  "item_service_request_tax_SR_ChangeValue";
export const SR_SERVICE_REQUEST_ITEM_TAXTYPE_SR_CHANGEVALUE =
  "item_service_request_taxtype_SR_ChangeValue";
export const SR_SERVICE_REQUEST_ITEM_GROSS_VAL_SR_CHANGEVALUE =
  "item_service_request_grossVal_SR_ChangeValue";
export const RFQ_MR_SR_SERVICE_REQUEST_ITEM_IMAGES_SR_MODEL_CLOSE =
  "SR_Q_service_request_sr_item_images_model_close";
export const MR_SR_SERVICE_REQUEST_ITEM_IMAGES =
  "SR_Q_service_request_sr_item_images";
export const MR_SR_SERVICE_REQUEST_ITEM_IMAGES_SUCCESS =
  "SR_Q_service_request_sr_item_images_Successful";
export const SR_SERVICE_REQUEST_QUOTATION_ADD =
  "SR_service_request_qoutation_add";
export const SR_SERVICE_REQUEST_QSR_ITEM_REMOVE =
  "SR_service_request_Qitem_remove";
// export const SR_QUOTATION_LIST = "SR_service_request_qoutation_list";
// export const SR_QUOTATION_LIST_SUCCESS = "SR_service_request_qoutation_list_success";
export const SR_SERVICE_REQUEST_QOUTATION_DATA =
  "SR_service_request_qoutation_data";
export const SR_SERVICE_REQUEST_QOUTATION_DATA_SUCCESS =
  "SR_service_request_qoutation_data_success";

export const SR_TOGGLE_ITEM_MENU = "po_SR_toggle_item_menu";
export const INPUT_SERVICE_REQUEST_CHANGEVALUE =
  "Q_input_Service_Request_ChangeValue";
export const SR_SET_PARAMS = "po_SR_set_params";
export const FILTER_INPUT_SR_CHANGEVALUE = "po_Filter_input_ChangeValue";
export const FILTER_SELECT_SR_CHANGEVALUE = "po_Filter_Select_ChangeValue";
export const SR_LIST_LAYOUT = "po_SR_list_layout";
export const PURCHASEREQUEST_SR_ROW_DATA = "purchaserequest_SR_Row_Data";
export const FILTERS_SHOW_SRQ_RIGHT_SIDEBAR =
  "PO_filter_show_SRQ_right_sidebar";
export const FILTERS_HIDE_SR_RIGHT_SIDEBAR = "PO_filter_hide_right_sidebar";
export const CLEAR_FILTER = "PO_clear_filter";

export const SR_PDF_DOWNNLOAD = "PO_SR_PDF_Download";

export const MR_SR_CODE_DETAILS = "PO_sr_code_details";
export const MR_SR_CODE_DETAILS_SUCCESS = "PO_sr_code_details_Successful";

export const PI_SR_CODE_DETAILS = "wo_pi_code_details";
export const PI_SR_CODE_DETAILS_SUCCESS = "wo_pi_code_details_Successful";

export const SR_PO_ITEM_ACKNOWLEDGE_OPEN = "PO_POIacknowledge_open";
export const PO_CLOSE_SR_MODAL_OPEN = "PO_CLOSE_SR_MODAL_OPEN";
export const PO_CLOSE_SR_MODAL_CLOSE = "PO_CLOSE_SR_MODAL_CLOSE";
export const SR_PO_ITEM_ACKNOWLEDGE_CLOSE = "PO_POIacknowledge_close";

export const SR_PO_ITEM_INPUT_SR_CHANGEVALUE =
  "PO_POIacknowledge_inputchangeValues";
export const PO_CLOSE_SR_DESCRIPTION = "PO_CLOSE_SR_DESCRIPTION";

export const SR_PO_ITEM_ACKNOWLEDGE = "PO_POIacknowledge_submit";

export const SR_PURCHASE_ORDER_CLOSE = "SR_purchase_order_close";

export const SR_PURCHASE_ORDER_FOUCS_POST = "SrPoFoucsPost";
export const SR_TOGGLE_EDIT = "SR_TOGGLE_EDIT";
export const SR_TOGGLE_EDIT_WITH_VALUE = "SR_TOGGLE_EDIT_WITH_VALUE";
export const HANDLE_SR_BASE_PRICE = "HANDLE_SR_BASE_PRICE";
export const ORDER_DISC_PERCENT_SR_CHANGEVALUE =
  "ORDER_desc_percent_ChangeValue";
export const ITEM_GROSS_VAL_SR_CHANGEVALUE = "ITEM_GROSS_VAL_SR_CHANGEVALUE";
export const ORDER_BASEPRICE_SR_CHANGEVALUE = "ORDER_BASEPRICE_SR_CHANGEVALUE";
export const ORDER_TAXTYPE_SR_CHANGEVALUE = "ORDER_TAXTYPE_SR_CHANGEVALUE";
export const ORDER_TAX_SR_CHANGEVALUE = "ORDER_TAX_SR_CHANGEVALUE";
export const SUBMIT_SR_EDIT_ORDER = "SUBMIT_SR_EDIT_ORDER";
export const SUBMIT_SR_EDIT_ORDER_SUCCESSFULL =
  "SUBMIT_SR_EDIT_ORDER_SUCCESSFULL";
export const VIEW_LOG_SHOW_SR_RIGHT_SIDEBAR_PURCHASE =
  "VIEW_LOG_SHOW_SR_RIGHT_SIDEBAR_PURCHASE";
export const VIEW_LOG_HIDE_SR_RIGHT_SIDEBAR_PURCHASE =
  "VIEW_LOG_HIDE_SR_RIGHT_SIDEBAR_PURCHASE";
export const ITEM_TIME_LINE = "po_item_time_line";
export const PO_SR_HISTORY = "PO_SR_HISTORY";
export const PO_SR_HISTORY_SUCCESS = "PO_SR_HISTORY_SUCCESS";

export const WO_AUTHORIZATION = "WO_AUTHORIZATION";
export const WO_AUTHORIZATION_SUCCESS = "WO_AUTHORIZATION_SUCCESS";
export const APPROVE_WO_EDIT_WITH_VALUE = "APPROVE_WO_EDIT_WITH_VALUE";

export const SET_MR_ERROR_MESSAGE = "SET_MR_ERROR_MESSAGE";

export const SR_VENDORS_MINI4_LIST = "SR_VENDORS_MINI4_LIST";
export const SR_VENDORS_MINI4_LIST_SUCCESS = "SR_VENDORS_MINI4_LIST_SUCCESS";
